<mat-card class="mcd-card view-all-detail-card">
  <mat-card-header class="mcd-card-header-dateModified">
    <mat-card-title style="font-weight: bold; ">

      <button
        style="background-color: #3F51B51A;color: #3F51B5;border: none;padding: 5px 11px; border-radius: 4px;font-weight: 600;font-size: 14px;"
        (click)="goBack()">
        <img src="/assets/images/back to list.svg" />
        Back
      </button>
      <span style="font-size: 16px;margin-left: 10px;">View National Standard</span></mat-card-title>

  </mat-card-header>
  <mat-card-content class="mcd-card-content nrbes-view">



    <!-- new detail UI starts here  -->

    <div *ngIf="!loading" style="padding: 20px;background-color: #f7f9fa;">
      <div class="review-page-container">
        <!-- Breadcrumb -->
        <div class="breadcrumbs clearfix">
          <div class="breadcrumbs-inner">
            <ul>
              <li>
                <a routerLink="/view-all-standards" routerLinkActive="active">All</a>
              </li>
              <li class="separator">/</li>
              <li class="active">{{ nrbesDetail.standard.title }}</li>
              <li style="
                      float: right;
                      border: 1px solid #3f51b5;
                      padding: 6px 10px;
                      border-radius: 4px;
                    ">
                <img src="/assets/images/social-sharing 1.svg" style=" margin-right: 4px" />

                <a style="
                        color: #3F51B5;
                        font-weight: 700;;
                        text-decoration: none;
                        cursor: pointer;
                      " (click)="downloadExcel()">Share
                </a>
              </li>
              <li style="
                      float: right;
                      border: 1px solid #3f51b5;
                      padding: 6px 10px;
                      border-radius: 4px;
                      margin-right: 10px;
                    ">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style="margin-bottom: 2px; margin-right: 2px">
                  <path d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z" stroke="#3C74E0" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                    stroke="#3C74E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                <a style="
                        color: #3F51B5;
                        font-weight: 700;;
                        text-decoration: none;
                        cursor: pointer;
                      " (click)="downloadExcel()">Download Standard
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- End Breadcrumb -->
        <!-- <div class="header"> -->
        <!-- <div class="stamp">{{ data.stampText }}</div> -->
        <!-- </div> -->

        <div class="info-main">
          <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                      margin-bottom: 20px;
                ">
            <h1 class="lastpage-title">
              {{ nrbesDetail.standard.title }}
            </h1>
            <!-- <img src="../../assets/images/global-minium-badge.svg" /> -->
          </div>
          <div style="display: flex">
            <div class="info-column left-column">
              <div class="info-row">
                <span class="reviewPage-icon date"></span>
                <span class="label left-label">New Restaurant Effective Date</span>
                <span class="value">{{
                  nrbesDetail.standard.newRestaurantsEffectiveFrom
                  | date: "dd, MMM yyyy"
                  }}</span>
              </div>

              <div class="info-row">
                <span class="reviewPage-icon date2"></span>
                <span class="label left-label">Existing Restaurant Effective Date</span>
                <span class="value">{{
                  nrbesDetail.standard.effectiveFrom | date: "dd, MMM yyyy"
                  }}</span>
              </div>

              <div class="info-row">
                <span class="reviewPage-icon standardType"></span>
                <span class="label left-label">Standard Type</span>
                <span class="value">{{ nrbesDetail.standard.standardType?.name }}</span>
              </div>

              <div class="info-row">
                <span class="reviewPage-icon createdOn"></span>
                <span class="label left-label">Last Updated</span>
                <span class="value">{{
                  nrbesDetail.standard.lastModifiedDate | date: "dd, MMM yyyy"
                  }}</span>
              </div>

              <!-- <div class="info-row">
                                <span class="icon clock-icon"></span>
                                <span class="label">Last Modified</span>
                                <span class="value">{{
                                  data.lastModified
                                }}</span>
                              </div> -->
            </div>

            <div class="divider"></div>

            <div class="info-column right-column">
              <div class="info-row">
                <span class="reviewPage-icon category"></span>
                <span class="label right-label">Category</span>
                <span class="value">
                  {{ nrbesDetail.standard.category?.name }}
                </span>
                <!-- <span
                                    class="value"
                                   
                                    >
                                    {{ categoryForLastPage }}
                                    </span
                                  > -->
              </div>
              <div class="info-row">
                <span class="reviewPage-icon location"></span>
                <span class="label right-label">Location</span>
                <span class="value">{{ allLocations }}</span>
              </div>

              <div class="info-row">
                <span class="reviewPage-icon Sublocation"></span>
                <span class="label right-label">Sub Location</span>
                <span class="value">{{
                  subLocations != "" ? subLocations : "--"
                  }}</span>
              </div>



              <div class="info-row">
                <span class="reviewPage-icon keyContact"></span>
                <span class="label right-label">Key Contact</span>
                <span class="value">{{ keyContactEmailResolved ? keyContactEmailResolved : "--" }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="showAdoptionBanner"
          style="
            background-color: #FFFBF1;
            border: 1px solid #ffe0a3;
            border-radius: 6px;
            padding: 12px 16px;
          "
        >
          <div
            *ngIf="adoptedMarkets.length === 1; else multiAdoptionHeader"
            style="display: flex; align-items: center; justify-content: space-between; gap: 12px; line-height: 1;"
          >
            <div style="color: #34393F; font-weight: 500; font-size: 15px; line-height: 1; display: flex; align-items: center; gap: 6px;">
              <img src="/assets/images/c-info 1.svg" alt="" style="width: 16px; height: 16px; display: block;" />
              <span>{{ adoptionBannerTitle }}</span>
            </div>
            <div style="color: #4D5258; font-size: 13px; font-weight: 400; line-height: 1; white-space: nowrap;">
              {{ getAdoptionLine(adoptedMarkets[0]) }}
            </div>
          </div>
          <ng-template #multiAdoptionHeader>
            <div style="color: #34393F; font-weight: 500; font-size: 15px; line-height: 1; display: flex; align-items: center; gap: 6px;">
              <img src="/assets/images/c-info 1.svg" alt="" style="width: 16px; height: 16px; display: block;" />
              <span>{{ adoptionBannerTitle }}</span>
            </div>
            <ol style="color: #4D5258; font-size: 13px; line-height: 1.6; margin: 6px 0 0 18px; padding: 0;">
              <li *ngFor="let market of adoptedMarkets">
                {{ getAdoptionLine(market) }}
              </li>
            </ol>
          </ng-template>
        </div>

        <div class="description-section" *ngIf="isSameDescription">
          <div style="display: flex; align-items: center">
            <h2 class="section-title">Description</h2>
            <button class="copyIcon">
              <img (click)="
                      copyText(nrbesDetail.standard.description);
                      $event.stopPropagation()
                    " src="../../assets/images/copy text.svg" alt="" />
            </button>
          </div>

          <p class="description-text">
            {{ nrbesDetail.standard.description }}
          </p>
        </div>

        <div class="description-wrapper" *ngIf="
                !isSameDescription &&
                (hasNewDescription || hasExistingDescription)
              " style="display: flex; gap: 20px">
          <!-- New Restaurant -->
          <div class="description-section" *ngIf="hasNewDescription" style="flex: 1">
            <div style="display: flex; align-items: center">
              <h2 class="section-title">Description for New Restaurant</h2>
              <button class="copyIcon">
                <img (click)="
                        copyText(nrbesDetail.standard.newRestaurantDescription);
                        $event.stopPropagation()
                      " src="../../assets/images/copy text.svg" alt="" />
              </button>
            </div>

            <p class="description-text">
              {{ nrbesDetail.standard.newRestaurantDescription }}
            </p>
          </div>

          <!-- Existing Restaurant -->
          <div class="description-section" *ngIf="hasExistingDescription" style="flex: 1">
            <div style="display: flex; align-items: center">
              <h2 class="section-title">
                Description for Existing Restaurant
              </h2>
              <button class="copyIcon">
                <img (click)="
                        copyText(nrbesDetail.standard.description);
                        $event.stopPropagation()
                      " src="../../assets/images/copy text.svg" alt="" />
              </button>
            </div>

            <p class="description-text">
              {{ nrbesDetail.standard.description }}
            </p>
          </div>
        </div>
        <!-- <div class="description-section">
              <div
                style="
                  display: flex;
                  align-items: center;
                  align-content: center;
                "
              >
                <h2 class="section-title"> New Restaurant Standard</h2>
                <button class="copyIcon">
                  <img
                    (click)="
                      copyText(nrbesDetail.standard.newRestaurantDescription);
                      $event.stopPropagation()
                    "
                    src="../../assets/images/copy text.svg"
                    alt=""
                  />
                </button>
              </div>
              <p class="description-text">
                {{ nrbesDetail.standard.newRestaurantDescription }}
              </p>
            </div>

            <div class="description-section">
              <div
                style="
                  display: flex;
                  align-items: center;
                  align-content: center;
                "
              >
                <h2 class="section-title">
                   Existing Restaurant Standard
                </h2>
                <button class="copyIcon">
                  <img
                    (click)="
                      copyText(nrbesDetail.standard.description);
                      $event.stopPropagation()
                    "
                    src="../../assets/images/copy text.svg"
                    alt=""
                  />
                </button>
              </div>
              <p class="description-text">
                {{ nrbesDetail.standard.description }}
              </p>
            </div> -->

        <div class="details-section" style="margin-top: 20px">
          <div class="details-header" (click)="toggleDetails()">
            <div class="details-title-wrapper">
              <div>
                <span class="toggle-icon">
                  <img *ngIf="!detailsExpanded" src="../../assets/images/s-add 1.svg" alt="Expand"
                    style="margin-bottom: 3px" />

                  <img *ngIf="detailsExpanded" src="../../assets/images/cross (2).svg" alt="Collapse"
                    style="margin-bottom: 3px" /></span>
                <!-- <span class="details-icon">☑</span> -->
                <span class="details-title" [ngClass]="{ 'details-title-expanded': detailsExpanded }"> Standard Details
                </span>
              </div>
              <div *ngIf="detailsExpanded">
                <img (click)="
                        copyText(nrbesDetail.standard.note);
                        $event.stopPropagation()
                      " src="../../assets/images/copy text.svg" alt="" />
              </div>
            </div>
          </div>

          <div class="details-content" [class.expanded]="detailsExpanded">
            <div [innerHTML]="getDetails()" class="detail-section"></div>
          </div>
        </div>

        <div class="details-section" style="margin-top: 20px" *ngIf="nrbesDetail.standard.additionalInformation">
          <div class="details-header" (click)="toggleDetails2()">
            <div class="details-title-wrapper">
              <div>
                <span class="toggle-icon">
                  <img [ngStyle]="{
                          display: additionalInfoExpanded ? 'none' : '',
                        }" *ngIf="!additionalInfoExpanded" src="../../assets/images/s-add 1.svg" alt="Expand"
                    style="margin-bottom: 3px" />
                  <img [ngStyle]="{
                          display: !additionalInfoExpanded ? 'none' : '',
                        }" *ngIf="additionalInfoExpanded" src="../../assets/images/cross (2).svg" alt="Collapse"
                    style="margin-bottom: 3px" /></span>
                <!-- <span class="details-icon">☑</span> -->
                <span class="details-title" [ngClass]="{ 'details-title-expanded': additionalInfoExpanded }"> Additional
                  Info </span>
              </div>
              <div *ngIf="additionalInfoExpanded">
                <img (click)="
                        copyText(nrbesDetail.standard.additionalInformation);
                        $event.stopPropagation()
                      " src="../../assets/images/copy text.svg" alt="" />
              </div>
            </div>
          </div>

          <div class="details-content" [class.expanded]="additionalInfoExpanded">
            <div [innerHTML]="getAdditionalInfo()" class="detail-section"></div>
          </div>
        </div>

        <div *ngIf="
                linksList?.length > 0 ||
                hardwareDescription
              " class="bottom-sections" [class.single-column]="
                (linksList?.length > 0 &&
                  !hardwareDescription) ||
                (!(linksList?.length > 0) &&
                  hardwareDescription)
              ">
          <div class="resources-section" *ngIf="linksList?.length > 0">
            <div class="section-header">
              <h2 class="section-heading">
                Resources and Supporting Information
              </h2>
              <span matTooltip="Information about Resources and Supporting Information" style="
                      background-image: url(&quot;/assets/images/Vector.svg&quot;);
                      background-repeat: no-repeat;
                      background-size: auto;
                      background-position: center;

                      padding: 10px;
                    "></span>
            </div>
            <div class="links-list">
              <a *ngFor="let link of linksList" [href]="link.url" class="resource-link" target="_blank">
                {{ link.title }}
              </a>
            </div>
          </div>

          <div class="hardware-section" *ngIf="hardwareDescription">
            <div class="section-header">
              <h2 class="section-heading">
                Global Approved Hardware/Equipment
              </h2>
              <span matTooltip="Information about Global Approved Hardware/Equipment" style="
                      background-image: url(&quot;/assets/images/Vector.svg&quot;);
                      background-repeat: no-repeat;
                      background-size: auto;
                      background-position: center;

                      padding: 10px;
                    "></span>
            </div>
            <div class="hardware-content">
              <a *ngIf="hardwareDescription.startsWith('http')" [href]="hardwareDescription" class="hardware-link"
                target="_blank">
                {{ hardwareDescription }}
              </a>
              <p *ngIf="!hardwareDescription.startsWith('http')" class="hardware-link"
                style="margin: 0; white-space: pre-line;">
                {{ hardwareDescription }}
              </p>
            </div>
          </div>
        </div>

        <!-- <div
                          >
                            <div class="section-header">
                              <h2 class="section-heading">
                                Global Approved Solutions
                              </h2>
                              <span class="info-icon-circle">?</span>
                            </div>
                            <div class="links-list">
                              <div class="dmos-cards-grid">
                                <div
                                  class="dmos-standard-card"
                                  *ngFor="
                                    let item of selectFromDepenedentStandard
                                  "
                                >
                                  <div class="dmos-card-header">
                                    <h3 class="dmos-card-title">
                                      {{ item.title }}
                                    </h3>
                                    <span
                                      class="dmos-category-badge dmos-building-site"
                                      >{{ item.category.name }}</span
                                    >
                                  </div>
                                  <div class="dmos-card-body">
                                    <p class="dmos-card-description">
                                      {{ item.description }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
        <div class="row" style="margin-top: 30px">

          <div class="btn-wrapper" style="display: flex;gap: 20px;">
            <div class="prev-button" *ngIf="!nrbesDetail.isFirst">
              <a class="nextPrevButtons" href="javascript:void(0)" (click)="slide(nrbesDetail.id, false)">
                <img src="/assets/images/arrow-right 2.svg" />
                Previous Standard
              </a>
            </div>
            <div class="next-button" *ngIf="!nrbesDetail.isLast">
              <a class="nextPrevButtons" href="javascript:void(0)" (click)="slide(nrbesDetail.id, true)">
                Next Standard
                <img src="/assets/images/arrow-right 1 (2).svg" />
              </a>
            </div>

          </div>


          <div class="row">




          </div>
        </div>
      </div>
    </div>


    <!-- new detail UI ends here -->



    <app-mcd-loader *ngIf="loading"></app-mcd-loader>
  </mat-card-content>
</mat-card>